import { useQuery, useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../../js/api/axios";

export const fetchAddToCollectionForm = async ({
  addToCollectionUrl
}) => {
  const response = await axiosInstance.get(addToCollectionUrl);
  return response.data;
};

export const useAddToCollectionForm = ({ addToCollectionUrl }) => {
  return useQuery({
    queryKey: ["add-to-collection", addToCollectionUrl],
    queryFn: () => fetchAddToCollectionForm({ addToCollectionUrl }),
  });
};

export const addColorsToCollection = async ({ url, body }) => {
  const response = await axiosInstance.post(url, body);
  return response.data;
};

export const useAddColor = () => {
  return useMutation({
    mutationFn: async ({ url, body }) => {
      return await addColorsToCollection({ url, body });
    },
    onSuccess: (data, { successHandler }) => {
      if (successHandler) {
        successHandler(data);
      }
    },
    onError: (data, { errorHandler }) => {
      if (errorHandler) {
        errorHandler(data);
      }
    },
  });
};

export const updateColorStateInCollection = async ({ url }) => {
  const response = await axiosInstance.post(url);
  return response.data;
};

export const useUpdateColorStateInCollection = () => {
  return useMutation({
    mutationFn: async ({ url }) => {
      return await updateColorStateInCollection({ url });
    },
    onSuccess: (data, { successHandler }) => {
      if (successHandler) {
        successHandler(data);
      }
    },
    onError: (data, { errorHandler }) => {
      if (errorHandler) {
        errorHandler(data);
      }
    },
  });
};